import {Action} from 'redux';
import {API} from '../../../utils/API';
import {guessTimezone} from '../../../utils/time-zone-formatter';
import {getDistinctId} from '../../../utils/tracker';
import {TProvider} from '../../../common/types';
import {SIGN_UP} from './constants';

export interface ISignUpAction extends Action {
  payload?: any;
  error?: boolean;
  meta: {
    provider: TProvider;
  };
}

const redirect = (action: ISignUpAction): void => {
  const redirectUrl: string | undefined = action.payload.redirectUrl;

  if (redirectUrl) {
    window.location.href = redirectUrl;
  }
};

export const registerUser = payload => dispatch => (
  dispatch({
    type: SIGN_UP,
    meta: {
      provider: payload.provider && payload.provider.name,
    },
    payload: API.postJSON('/user/signup', {
      ...payload,
      timezone: guessTimezone(),
      distinctId: getDistinctId(),
    }),
  }).then(({action}) => redirect(action))
);
